import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    banner: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(0, 0, 0, .95)',
      zIndex: '99999',
    },
    message: {
      fontSize: 20,
      width: '90%',
    },
  };
});

const GroupShowOverlay = () => {
  const classes = useStyles();

  return (
    <Box
      alignItems="center"
      className={classes.banner}
      display="flex"
      justifyContent="center"
    >
      <Typography className={classes.message}>
        Party Show is about to start
      </Typography>
    </Box>
  );
};

export default GroupShowOverlay;
